/* eslint-disable max-classes-per-file */

export class VacationYearPeriodStatus {
    public static readonly Upcoming: string = 'Upcoming';
    public static readonly OpenRoundOne: string = 'OpenRoundOne';
    public static readonly OpenRoundTwo: string = 'OpenRoundTwo';
    public static readonly Approval: string = 'Approval';
    public static readonly Extended: string = 'Extended';
    public static readonly Closed: string = 'Closed';
}

export class VacationRequestPriority {
    public static readonly low: string = 'Low';
    public static readonly medium: string = 'Medium';
    public static readonly high: string = 'High';
}

export class VacationRequestColorizeType {
    public static readonly slashed: string = 'Slashed';
}

export class VacationRequestType {
    public static readonly vac_p: string = 'VAC_P';
    public static readonly vac_s: string = 'VAC_S';
    public static readonly vac_n: string = 'VAC_N';
    public static readonly vac_v: string = 'VAC_V';
    public static readonly ubu: string = 'UBU';
    public static readonly vac: string = 'VAC';
    public static readonly vac_w: string = 'VAC_W';
    public static readonly ubu_j_s: string = 'UBU_J_S';
    public static readonly ubu_c: string = 'UBU_C';
    public static readonly ubu_p: string = 'UBU_P';
    public static readonly ubu_k: string = 'UBU_K';
    public static readonly ubu_plus: string = 'UBUplus';
}

export class PersonRequestVacDecision {
    public static readonly None: string = 'None';
    public static readonly Confirmed: string = 'Confirmed';
    public static readonly Denied: string = 'Denied';
    public static readonly ConfirmedAlternative: string = 'ConfirmedAlternative';
    public static readonly DeniedAlternative: string = 'DeniedAlternative';
}

export enum PersonRequestVacDecisionEnum {
    None = 0,
    Confirmed = 1,
    Denied = 2,
    ConfirmedAlternative = 3,
    DeniedAlternative = 4
}

export class PersonAlternativeRequestDecision {
    public static readonly Accept: string = 'Accept';
    public static readonly Decline: string = 'Decline';
}

export class PersonRequestVac14DaysRuleStatus {
    public static readonly IsNotFulfilledYetButCanBe: string = 'IsNotFulfilledYetButCanBe';
    public static readonly IsFulfilled: string = 'IsFulfilled';
    public static readonly IsNotFulfilled: string = 'IsNotFulfilled';
}

export class PersonRequestVacCategory {
    public static readonly Variant: string = 'Variant';
    public static readonly Alternative: string = 'Alternative';
    public static readonly Reality: string = 'Reality';
}

export class RequestStatusDisplayName {
    public static readonly RequestedToApprove: string = 'Requested To Approve';
    public static readonly RequestedToRemove: string = 'Requested To Remove';
    public static readonly Approved: string = 'Approved';
    public static readonly Rejected: string = 'Rejected';
    public static readonly RejectedByPlanning: string = 'Rejected by Planning';
    public static readonly RejectedByCrew: string = 'Rejected by Crew';
    public static readonly RejectedByCancellation: string = 'Rejected by Cancellation';
    public static readonly Requested: string = 'Requested';
    public static readonly ManualAction: string = 'ManualAction';
}

export class PersonRequestSummaryStatus {
    public static readonly InProgress: string = 'InProgress';
    public static readonly Approved: string = 'Approved';
    public static readonly Rejected: string = 'Rejected';
    public static readonly Requested: string = 'Requested';
}

export class PersonRequestType {
    public static readonly Vacation: string = 'Vacation';
    public static readonly STO: string = 'STO';
    public static readonly LTO: string = 'LTO';
    public static readonly LTE: string = 'LTE';
    public static readonly Flight: string = 'Flight';
    public static readonly Reserve: string = 'Reserve';
}

export class PersonRequestVacStatus {
    public static readonly RequestedToApprove: string = 'RequestedToApprove';
    public static readonly Pending: string = 'Pending';
    public static readonly Confirmed: string = 'Confirmed';
    public static readonly Denied: string = 'Denied';
    public static readonly ManualAction: string = 'ManualAction';
}

export class PersonRequestVacBlockStatus {
    public static readonly Requested: string = 'Requested';
    public static readonly Pending: string = 'Pending';
    public static readonly AlternativePending: string = 'Alternative_Pending';
    public static readonly Closed: string = 'Closed';
    public static readonly AlternativeOffered: string = 'Alternative_Offered';
}

export enum PersonRequestVacBlockStatusEnum {
    Requested = 0,
    Pending = 1,
    AlternativePending = 2,
    Closed = 3,
    AlternativeOffered = 4
}

export enum TypeRatingEnum {
    A320 = 1,
    A330 = 2,
    A340 = 3,
    A334 = 4,
    A320Only = 5,
    A330Only = 6,
    A340Only = 7,
    A320And330Only = 8,
    A320And340Only = 9,
    A330And340Only = 10
}
